export class FDAHelper {
    static addEditFDACitationModalId = "add-edit-fda-citation-modal-id";
    static partAndSectionIndex = 0;
    static descriptionIndex = 1;
    static applicableSubsectionsIndex = 2;
    static anyRestrictionsIndex = 3;
    static commentsIndex = 4;
    static partIndex = 0;
    static sectionIndex = 1;
    static partAndCitationSeparator = ".";
    static citationDescriptionSeparator = " - ";
    static dropDownDefaultValue = " ";
    static notApplicableSectionsValue = "N/A";
    static subSectionsSeparator = "; ";
    static citationPrefix = "§";
}